/* Coffee Finder quiz — vanilla JS, no dependencies.
   Reads product data serialized by sections/coffee-finder.liquid,
   walks 6 questions, maps answers to a main pick + 2 alternatives. */
(function () {
  var root = document.querySelector('[data-cf-quiz]');
  if (!root) return;

  var section = root.closest('.coffee-finder');
  var dataEl = section.querySelector('[data-cf-data]') || document.querySelector('[data-cf-data]');
  if (!dataEl) return;
  var PRODUCTS = {};
  try { PRODUCTS = JSON.parse(dataEl.textContent).products || {}; } catch (e) { return; }

  var QUESTIONS = [
    { key: 'who', q: "Who's the coffee for?", opts: [
      { v: 'me', label: 'For me' },
      { v: 'gift', label: "It's a gift" }
    ]},
    { key: 'brew', q: 'How do you brew at home?', opts: [
      { v: 'espresso', label: 'Espresso machine' },
      { v: 'filter', label: 'Pour over, plunger or filter' },
      { v: 'none', label: 'No gear — keep it easy' }
    ]},
    { key: 'milk', q: 'Milk or black?', opts: [
      { v: 'milk', label: 'Mostly with milk' },
      { v: 'black', label: 'Mostly black' },
      { v: 'both', label: 'Both' }
    ]},
    { key: 'flavour', q: 'Which flavours sound like you?', opts: [
      { v: 'fruity', label: 'Bright and fruity' },
      { v: 'choc', label: 'Chocolatey and sweet' },
      { v: 'bold', label: 'Dark and bold' }
    ]},
    { key: 'caf', q: 'Caffeine?', opts: [
      { v: 'regular', label: 'Regular' },
      { v: 'decaf', label: 'Decaf, please' }
    ]},
    { key: 'amount', q: 'How much coffee do you go through?', opts: [
      { v: 'light', label: 'A cup a day or less' },
      { v: 'heavy', label: 'A few cups a day' },
      { v: 'try', label: 'I just want to try first' }
    ]}
  ];

  var els = {
    intro: section.querySelector('[data-cf-intro]'),
    quiz: root,
    step: section.querySelector('[data-cf-step]'),
    back: section.querySelector('[data-cf-back]'),
    progressText: section.querySelector('[data-cf-progress-text]'),
    progressBar: section.querySelector('[data-cf-progress-bar]'),
    result: section.querySelector('[data-cf-result]'),
    resultMain: section.querySelector('[data-cf-result-main]'),
    resultAlts: section.querySelector('[data-cf-result-alts]'),
    altsHeading: section.querySelector('[data-cf-alts-heading]'),
    start: section.querySelector('[data-cf-start]'),
    restart: section.querySelector('[data-cf-restart]')
  };

  var answers = {};
  var stepIndex = 0;

  function track(name, detail) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'coffee_finder', action: name, detail: detail || '' });
    } catch (e) { /* no-op */ }
  }

  function show(el) { el.hidden = false; }
  function hide(el) { el.hidden = true; }

  function renderStep() {
    var q = QUESTIONS[stepIndex];
    els.progressText.textContent = (stepIndex + 1) + ' / ' + QUESTIONS.length;
    els.progressBar.style.width = (((stepIndex + 1) / QUESTIONS.length) * 100) + '%';
    els.back.hidden = stepIndex === 0;

    var html = '<h3 class="coffee-finder__question">' + q.q + '</h3><div class="coffee-finder__options">';
    q.opts.forEach(function (o) {
      var selected = answers[q.key] === o.v ? ' is-selected' : '';
      html += '<button type="button" class="coffee-finder__option' + selected + '" data-value="' + o.v + '">' + o.label + '</button>';
    });
    html += '</div>';
    els.step.innerHTML = html;
    els.step.classList.remove('is-entering');
    void els.step.offsetWidth; /* restart CSS transition */
    els.step.classList.add('is-entering');

    els.step.querySelectorAll('.coffee-finder__option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        answers[q.key] = btn.getAttribute('data-value');
        if (stepIndex < QUESTIONS.length - 1) { stepIndex++; renderStep(); }
        else { finish(); }
      });
    });
  }

  function recommend(a) {
    var main, alts;
    if (a.caf === 'decaf') { main = 'decaf'; alts = ['taster', 'latte']; }
    else if (a.brew === 'none') { main = 'drip'; alts = ['taster', 'decaf']; }
    else if (a.brew === 'filter') { main = 'gilded'; alts = ['merlin', 'drip']; }
    else if (a.milk === 'milk') {
      if (a.flavour === 'fruity') { main = 'merlin'; alts = ['latte', 'bfg']; }
      else if (a.flavour === 'bold') { main = 'dark'; alts = ['bfg', 'latte']; }
      else { main = 'latte'; alts = ['bfg', 'dark']; }
    } else if (a.milk === 'black') {
      if (a.flavour === 'fruity') { main = 'merlin'; alts = ['gilded', 'bfg']; }
      else if (a.flavour === 'bold') { main = 'dark'; alts = ['bfg', 'merlin']; }
      else { main = 'bfg'; alts = ['latte', 'merlin']; }
    } else {
      if (a.flavour === 'fruity') { main = 'merlin'; alts = ['gilded', 'latte']; }
      else if (a.flavour === 'bold') { main = 'dark'; alts = ['bfg', 'latte']; }
      else { main = 'bfg'; alts = ['latte', 'gilded']; }
    }
    if ((a.who === 'gift' || a.amount === 'try') && main !== 'taster') {
      alts = [main].concat(alts).slice(0, 2);
      main = 'taster';
    }
    alts = alts.filter(function (k, i) { return k !== main && alts.indexOf(k) === i && PRODUCTS[k]; });
    if (!PRODUCTS[main]) { main = alts.shift(); }
    return { main: main, alts: alts.slice(0, 2) };
  }

  function pickVariant(key, p, a) {
    var vs = p.variants.filter(function (v) { return v.available !== false; });
    if (!vs.length) vs = p.variants;
    function has(v, s) { return v.title.toLowerCase().indexOf(s) !== -1; }
    var pool = vs;
    if (key === 'gilded') {
      var roast = a.flavour === 'choc' ? 'medium' : 'light';
      var roastPool = vs.filter(function (v) { return has(v, roast); });
      if (roastPool.length) pool = roastPool;
    }
    if (key === 'taster') {
      var grind = a.brew === 'none' ? 'ground' : 'wholebean';
      var gPool = vs.filter(function (v) { return has(v, grind); });
      if (gPool.length) return gPool[0];
    }
    var wantBig = a.amount === 'heavy';
    var sized = pool.filter(function (v) { return wantBig ? has(v, '1 kg') || has(v, '1kg') : has(v, '200') || has(v, '250'); });
    return sized[0] || pool[0];
  }

  function badge(p) {
    return (p.tags || []).indexOf('award-winning') !== -1
      ? '<span class="coffee-finder__badge">Award winner</span>' : '';
  }

  function card(key, main) {
    var p = PRODUCTS[key];
    var v = pickVariant(key, p, answers);
    var cls = main ? 'coffee-finder__card coffee-finder__card--main' : 'coffee-finder__card';
    var html = '<div class="' + cls + '">';
    if (p.image) html += '<a href="' + p.url + '"><img class="coffee-finder__card-img" src="' + p.image + '" alt="" loading="lazy"></a>';
    html += '<div class="coffee-finder__card-body">';
    html += badge(p);
    html += '<h4 class="coffee-finder__card-title"><a href="' + p.url + '">' + p.title + '</a></h4>';
    if (main && p.description) html += '<p class="coffee-finder__card-desc">' + p.description + '</p>';
    html += '<p class="coffee-finder__card-price">' + v.title + ' &middot; ' + v.price + '</p>';
    html += '<button type="button" class="button' + (main ? ' button--primary' : '') + '" data-cf-add="' + v.id + '">Add to cart</button>';
    html += '</div></div>';
    return html;
  }

  function bindAddToCart(container) {
    container.querySelectorAll('[data-cf-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.disabled = true;
        var original = btn.textContent;
        btn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(btn.getAttribute('data-cf-add')), quantity: 1 })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          btn.textContent = 'Added ✓';
          track('add_to_cart', btn.getAttribute('data-cf-add'));
          var link = document.createElement('a');
          link.href = '/cart';
          link.className = 'coffee-finder__cart-link link';
          link.textContent = 'View cart →';
          if (!btn.parentNode.querySelector('.coffee-finder__cart-link')) btn.parentNode.appendChild(link);
          refreshCartBubble();
        }).catch(function () {
          btn.disabled = false;
          btn.textContent = original;
        });
      });
    });
  }

  function refreshCartBubble() {
    fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (d) {
      var current = document.getElementById('cart-icon-bubble');
      if (current && d['cart-icon-bubble']) {
        var tmp = document.createElement('div');
        tmp.innerHTML = d['cart-icon-bubble'];
        var next = tmp.querySelector('#cart-icon-bubble') || tmp.firstElementChild;
        if (next) current.innerHTML = next.innerHTML;
      }
    }).catch(function () { /* no-op */ });
  }

  function showResult(rec) {
    hide(els.quiz); hide(els.intro); show(els.result);
    els.resultMain.innerHTML = card(rec.main, true);
    els.resultAlts.innerHTML = rec.alts.map(function (k) { return card(k, false); }).join('');
    els.altsHeading.hidden = rec.alts.length === 0;
    bindAddToCart(els.result);
    track('result', rec.main);
  }

  function finish() {
    var rec = recommend(answers);
    try { sessionStorage.setItem('cf-state', JSON.stringify(answers)); } catch (e) { /* no-op */ }
    showResult(rec);
  }

  els.start.addEventListener('click', function () {
    hide(els.intro); show(els.quiz);
    stepIndex = 0; renderStep();
    track('start');
  });
  els.back.addEventListener('click', function () {
    if (stepIndex > 0) { stepIndex--; renderStep(); }
  });
  els.restart.addEventListener('click', function () {
    answers = {}; stepIndex = 0;
    try { sessionStorage.removeItem('cf-state'); } catch (e) { /* no-op */ }
    hide(els.result); show(els.quiz); renderStep();
  });

  /* After the email form posts, Shopify reloads the page — restore the result
     so the shopper still sees their match next to the discount code. */
  var posted = /customer_posted=true/.test(location.search) || /#contact_form/.test(location.hash) || section.querySelector('[data-cf-email-success]');
  if (posted) {
    try {
      var saved = JSON.parse(sessionStorage.getItem('cf-state') || 'null');
      if (saved && saved.brew) { answers = saved; showResult(recommend(saved)); }
    } catch (e) { /* no-op */ }
  }
})();
